<ng-template #view>
  <ion-grid data-cy="user-profile-header" *ngIf="user">
    <ion-row>
      <ion-col>
        <ion-chip color="dark" *ngIf="user | isInstallerTeamLead">
          <ion-label>TEAM</ion-label>
        </ion-chip>
      </ion-col>
      <ion-col class="ion-text-center">
        <img
          alt="{{ user | fullName }}"
          [class.user-avatar]="centered"
          [src]="user | profilePhoto"
          class="profile-picture"
        />
      </ion-col>
      <ion-col class="ion-text-end">
        <ng-content></ng-content>
        <ion-buttons class="ion-justify-content-end">
          <ion-button target="_blank" href="mailto:{{ user.email }}">
            <ion-icon color="dark" slot="icon-only" name="mail-open-outline"></ion-icon>
          </ion-button>
          <ion-button *ngIf="user | isInstallerTeamLead" (click)="showInstallerTeamLeadProfile(user)" id="profile-btn">
            <ion-icon color="dark" name="person-circle-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col class="ion-text-center">
        <h1>{{ user | fullName }}</h1>
        <!-- TT-238: labelled pills, each opening the full profile like the profile icon above. -->
        <div class="stat-pills" *ngIf="user | isInstallerTeamLead">
          <button
            type="button"
            class="stat-pill"
            *ngIf="isDetailedInstaller(user) && $any(user).keyHammerRating"
            (click)="showInstallerTeamLeadProfile($any(user))"
            data-cy="stat-pill-rank"
          >
            Rank: <b>{{ rankFor($any(user).keyHammerRating) }}</b>
          </button>
          <button type="button" class="stat-pill" (click)="showInstallerTeamLeadProfile($any(user))" data-cy="stat-pill-kudos">
            Kudos: <b>{{ $any(user).kudos ?? 0 }}</b>
          </button>
          <button
            type="button"
            class="stat-pill"
            (click)="showInstallerTeamLeadProfile($any(user))"
            data-cy="stat-pill-completed"
          >
            Completed WO's: <b>{{ $any(user).completedWorkOrders ?? 0 }}</b>
          </button>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="user | isInstallerTeamLead" class="ion-text-center display-grid">
      <ion-col
        size="6"
        [attr.size-md]="!!$any(user).keyHammerRating ? 3 : 4"
        class="flex flex-column ion-justify-content-center"
      >
        <ion-icon name="checkmark-circle" color="gc-green" size="large"></ion-icon>
        <ion-text color="dark" style="margin-top: 15px">W9</ion-text>
        <ion-text color="gc-green">Passed</ion-text>
      </ion-col>

      <ion-col
        size="6"
        [attr.size-md]="!!$any(user).keyHammerRating ? 3 : 4"
        class="flex flex-column ion-justify-content-center"
      >
        <ion-icon
          [name]="validInsurance(user) ? 'checkmark-circle' : 'warning'"
          [color]="validInsurance(user) ? 'gc-green' : 'danger'"
          size="large"
        ></ion-icon>
        <ion-text color="dark" style="margin-top: 15px">Certificate of Insurance</ion-text>
        <ion-text [color]="validInsurance(user) ? 'gc-green' : 'danger'"
          >{{ validInsurance(user) ? 'Valid' : 'Expired' }}
        </ion-text>
      </ion-col>

      <ion-col
        size="6"
        [attr.size-md]="!!$any(user).keyHammerRating ? 3 : 4"
        class="flex flex-column ion-justify-content-center"
      >
        <ion-text class="value value-bronze">BRONZE</ion-text>
        <ion-text color="dark" style="margin-top: 15px">Verification Level</ion-text>
      </ion-col>

      <ion-col
        size="6"
        size-md="3"
        class="flex flex-column ion-justify-content-center"
        *ngIf="isDetailedInstaller(user) && $any(user).keyHammerRating"
      >
        <ion-text class="value" color="dark">
          <ion-icon
            *ngIf="!meetsHammerRatingThreshold(user)"
            name="warning"
            color="warning"
            size="medium"
            style="transform: translateY(3px)"
          ></ion-icon>
          {{ $any(user).keyHammerRating }}
        </ion-text>
        <ion-text color="dark" style="margin-top: 15px">Verified Trade Index (VTI)</ion-text>
        <ion-text [color]="meetsHammerRatingThreshold(user) ? 'gc-green' : 'warning'"
          >{{ meetsHammerRatingThreshold(user) ? 'Passed' : 'Below minimum' }}
        </ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-template>

<ng-container *ngIf="isLoading; else view">
  <ion-grid data-cy="user-profile-header">
    <ion-row>
      <ion-col>
        <ion-chip color="dark">
          <ion-skeleton-text></ion-skeleton-text>
        </ion-chip>
      </ion-col>
      <ion-col class="ion-text-center">
        <ion-skeleton-text></ion-skeleton-text>
      </ion-col>
      <ion-col class="ion-text-end"></ion-col>
    </ion-row>

    <ion-row>
      <ion-col class="ion-text-center">
        <ion-skeleton-text></ion-skeleton-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>
